import * as ActionTypes from '../action-types'

const vehicleReportDailySummaries_DefaultState = {
    reportByVID: {},
    summary: {},
    allVIDs: [],
    startTime: 0,
    endTime: 0,
    // objReportByVID: {},
    // objSummaries: {}
}

export const vehicleReportDailySummaries = (state = vehicleReportDailySummaries_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    // const temp = {}

    switch (action.type) {
        case ActionTypes.GET_VEHICLE_DAILY_SUMMARY_REPORTS: {

            const reportVehicleDailySummary = action.reportVehicleDailySummary
            const summary = action.summary
            const vid = action.vid
            const startTime = action.startTime
            const endTime = action.endTime

            newState.startTime = startTime
            newState.endTime = endTime
            
            if(vid) {

                if(!newState.reportByVID[vid]) {
                    newState.reportByVID[vid] = []
                }

                newState.reportByVID[vid] = reportVehicleDailySummary
                // newState.objReportByVID[`${vid}#${startTime}`] = reportVehicleDailySummary[0]
                
                if(summary) {
                    newState.summary[vid] = summary
                    // newState.objSummaries[`${vid}#${startTime}`] = summary
                }
            }

            return newState
        }
        case ActionTypes.GET_VEHICLE_SUMMARY_REPORTS: {

            const reportVehicleDailySummary = action.reportVehicleDailySummary
            const summary = action.summary
            const vid = action.vid

            
            if(vid) {
                
                newState.reportByVID[vid] = reportVehicleDailySummary

                if(!newState.allVIDs.includes(vid)) newState.allVIDs.push(vid)

                if(summary) {
                    newState.summary[vid] = summary
                }
            }

            return newState
        }
        case ActionTypes.CLEAR_VEHICLE_DAILY_SUMMARY_REPORTS: {

            newState.reportByVID = {}
            newState.objReportByVID = {}
            newState.allVIDs = []
            newState.summary = {}

            return newState
        }
        default: {
            return newState;
        }
    }
}
